import React from 'react';

const SuccessCheckIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden="true"
  >
    <circle cx="8" cy="8" r="8" fill="#176F2C" />
    <path
      d="M5 8.5L7 10.5L11 6.5"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SuccessCheckIcon;
